/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Tut_Daftar_S1Inputs */

const en_mk_tut_daftar_s1 = /** @type {(inputs: Mk_Tut_Daftar_S1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open the **Sign in** page and choose **Continue with Google** if your work email is on Google.`)
};

const id_mk_tut_daftar_s1 = /** @type {(inputs: Mk_Tut_Daftar_S1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buka halaman **Masuk**, lalu pilih **Lanjut dengan Google** kalau email kerja Anda memakai Google.`)
};

/**
* | output |
* | --- |
* | "Open the **Sign in** page and choose **Continue with Google** if your work email is on Google." |
*
* @param {Mk_Tut_Daftar_S1Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_tut_daftar_s1 = /** @type {((inputs?: Mk_Tut_Daftar_S1Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Tut_Daftar_S1Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_tut_daftar_s1(inputs)
	return en_mk_tut_daftar_s1(inputs)
});